import { IApplicationErrorInfo } from '../common/interfaces/errors.interface';

export default class ApplicationError extends Error {
  constructor(public readonly errorMessage: string,
              public readonly info?: IApplicationErrorInfo) {
    super(errorMessage);
    Object.setPrototypeOf(this, ApplicationError.prototype);
  }
}
